<template>
    <div class="oldest-view">
        <div
            v-for="oldItemCard in oldestItems"
            class="oldest-view__card"
            :key="oldItemCard.id"
            :class="oldItemCard.class"
        >
            <div class="oldest-view__card--header">
                <h4 class="oldest-view__card--header--title">
                    <span class="oldest-view__card--header--title--quantity">{{ oldItemCard.totalItems }}</span>
                    {{ oldItemCard.name }}
                </h4>
                <div class="oldest-view__card--header--actions">
                    <a-button
                        type="primary"
                        class="oldest-view__card--header--actions--btn"
                        @click="handlerDeleteMany(oldItemCard.schema, oldItemCard.data)"
                        :disabled="!oldItemCard.data.length"
                    >
                        <fa-icon :icon="['fas', 'trash-can']" class="mr-2" />
                        Eliminar Todos
                    </a-button>
                </div>
            </div>
            <div v-if="oldItemCard.isLoading" class="oldest-view__card--loading">
                <fa-icon :icon="['fas', 'spinner']" class="fa-spin mr-2" />
                Cargando
            </div>
            <div v-else-if="oldItemCard.data.length" class="oldest-view__card--body">
                <div class="oldest-view__card--body--header">
                    <h4
                        v-for="(heading, idx) in oldItemCard.dataHeads"
                        :key="idx"
                        class="oldest-view__card--body--header--title min-width-100"
                    >
                        {{ heading.label }}
                    </h4>
                </div>
                <div v-for="item in oldItemCard.data" class="oldest-view__card--body--item" :key="item.id">
                    <p class="oldest-view__card--body--item--id">
                        {{ item.serie }}
                    </p>
                    <p class="oldest-view__card--body--item--name">
                        {{ item.name }}
                    </p>
                    <p class="oldest-view__card--body--item--date">
                        <fa-icon :icon="['fas', 'timer']" class="mr-1" />
                        {{ $moment(item.date).format('DD/MM/YYYY') }}
                    </p>
                    <a-button
                        type="danger"
                        class="oldest-view__card--actions--btn"
                        @click="handlerDeleteItem(oldItemCard.schema, item.id)"
                        :disabled="!oldItemCard.data.length"
                    >
                        <fa-icon :icon="['fas', 'trash-can']" />
                    </a-button>
                </div>
            </div>
            <div v-else class="oldest-view__card--nothing">
                <p class="oldest-view__card--nothing--text">
                    <fa-icon :icon="['fas', 'circle-exclamation']" class="mr-2" />
                    No se encontraron registros con fecha posterior a hace {{ yearsInThePast }} años para visualizar
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import Actions from './_actions'
import Variables from './_variables'
export default {
    mixins: [Actions],
    data() {
        return Variables()
    },
}
</script>

<style scoped lang="scss">
@import './styles.scss';
</style>
